<template>
  <div class="drag" :id="dragId">
    <div
      class="real"
      ref="real"
      :style="realStyle"
      @touchmove="touchMove"
      @touchend="touchEnd"
      @touchstart="touchStart"
      @touchcancel="touchEnd"
    >
      <slot></slot>
    </div>
    <div
      class="duplicate"
      ref="duplicate"
      :style="duplicateStyle"
      v-html="$xss(duplicateHTML)"
    ></div>
  </div>
</template>

<script type="text/ecmascript-6">
import {overlap, getGUID} from './util'

export default {
  name: 'drag',
  props: {
    target: {type: String, default: null},
    packet: {type: Object},
    zIndex: {type: Number, default: 10},
    duplicate: {type: Boolean, default: false},
    constantly: {type: Boolean, default: false}
  },
  data () {
    return {
      dragId: getGUID(),
      realStyle: {zIndex: this.zIndex},
      duplicateStyle: {zIndex: this.zIndex},
      duplicateHTML: '',
      scrollTop: '' // 页面滚动的距离
    }
  },
  methods: {
    _setStyle (style = {}) {
      style = Object.assign({}, {zIndex: this.zIndex}, style)
      if (this.duplicate) {
        this._createDuplicate()
        this.duplicateStyle = style
      } else {
        this.realStyle = style
      }
    },
    _createDuplicate () {
      this.duplicateHTML = this.$refs.real.innerHTML
    },
    _getDropComponents () {
      let dropList = []
      let filter = (components) => {
        if (!components.length) {
          return
        }
        for (let i = 0; i < components.length; i++) {
          let child = components[i]
          let options = child.$options
          if (options._componentTag === 'drop') {
            // if (!this.target) {} else {
            //   if (options.propsData && options.propsData.name === this.target) {
            //     dropList.push(child)
            //   }
            // }
            if(this.target){
              if (options.propsData && options.propsData.name === this.target) {
                dropList.push(child)
              }
            }
          }
          if (child.$children.length) {
            filter(child.$children)
          }
        }
      }
      filter(this.$root.$children)
      return dropList
    },
    _detectObjective () {
      let dropList = []
      let dom1 = this.duplicate ? this.$refs.duplicate : this.$refs.real
      let dropComponents = this._getDropComponents()
      dropComponents.forEach(item => {
        if (overlap(dom1, item.$el)) {
          dropList.push(item)
        }
        item.away()
      })
      let drop = dropList.length ? dropList[0] : null
      if (drop) {
        drop.arrive(this)
      }
      return drop
    },
    touchMove (event) {
      //        console.log($('.drag').offset().top-event.targetTouches[0].clientY);
      //        console.log($('.drag').offset().top);
      //        window.event? window.event.cancelBubble = true : e.stopPropagation();

      /* 判断选项竖向滑动超过一定距离为拖动，不然为横向滑动 */
      if ($('.drag').offset().top - event.targetTouches[0].pageY > 0) {
        this.ModalHelper('modal-open').afterOpen()// 解决滚动穿透
        //          console.log(event);
        //          alert($('.drag').offset().top+'------'+event.targetTouches[0].pageY+'----'+document.documentElement.scrollTop+'---'+document.body.scrollTop);

        /* 拖动时去掉 -webkit-overflow-scrolling: touch; 这个导致拖动元素会有穿透问题，需要在拖拽元素出来后去掉 */
        $('.test_test').removeClass('touch')
        //          $('.test_test').css('-webkit-overflow-scrolling','auto');
        $('.test_options li').removeClass('trans')

        if (event.touches.length > 1) {
          //            禁止2个手指以上的事件
          return false
        }
        if (event.targetTouches.length === 1) {
          let touch = event.targetTouches[0]
          let target = event.target
          if (this.duplicate) {
            this._createDuplicate()
          }
          //            console.log(this);
          this._setStyle({
            position: 'fixed',
            display: 'block',
            opacity: '1',
            top: `${touch.pageY - target.offsetHeight / 2}px`,
            left: `${touch.pageX - target.offsetWidth / 2}px`,
            width: `${target.offsetWidth}px`,
            height: `${target.offsetHeight}px`
          })
          if (this.constantly) {
            this._detectObjective()
          }
          $(event.target).parents('li').children('.model').addClass('model_over')
        }
      }
    },
    touchEnd (event) {
      //        alert('结束')

      this.ModalHelper('modal-open').beforeClose()

      if (this.duplicate) {
        this.duplicateHTML = ''
      }
      this._setStyle()
      this.$emit('dragend', event, this, this._detectObjective())

      /* 拖动结束加上-webkit-overflow-scrolling: touch; 启动硬件加速，使ios横向滑动更顺滑 */
      //        $('.test_test').css('-webkit-overflow-scrolling','touch');

      //        setTimeout(()=>{
      $('.test_test').addClass('touch')
      //        $('.test_options').css('top','0');

      $('.test_options li').addClass('trans')

      //        },1000);
    },
    touchStart () {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      //        console.log( this.scrollTop);
    },
    // 解决滚动穿透
    ModalHelper (bodyCls) {
      //        var scrollTop;
      //        console.log(this.scrollTop);
      var _this = this
      return {
        afterOpen: function () {
          //            scrollTop = document.documentElement.scrollTop;
          document.body.classList.add(bodyCls)
          document.documentElement.classList.add(bodyCls)
          document.body.style.top = -_this.scrollTop + 'px'
        },
        beforeClose: function () {
          document.body.classList.remove(bodyCls)
          document.documentElement.classList.remove(bodyCls)
          // scrollTop lost after set position:fixed, restore it back.
          document.documentElement.scrollTop = _this.scrollTop
          document.body.scrollTop = _this.scrollTop
        }
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/sass">
.drag {
  .duplicate {
    display: none;
  }
}
body.modal-open {
  position: fixed;
  width: 100%;
}
html.modal-open {
  overflow: hidden;
}
</style>
